export const isValidSendTime = (time: string): boolean =>
  /^(1[0-2]|0?[1-9]):[0-5][0-9]$/.test(time);
